<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import { attendanceLog } from "./entries";

/**
 * Attendance component
 */
export default {
  page: {
    title: "Attendance",
  },
  components: { Layout, PageHeader },
  data() {
    return {
      attendanceLog,
      title: "Attendance",
      items: [
        {
          text: "HR",
          href: "/",
        },
        {
          text: "Attendance",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.attendanceLog.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onRowSelected(row) {
      console.log(row);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                hover
                striped
                :items="attendanceLog"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #head()="head">
                  <div v-if="['id', 'employee'].includes(head.field.key)">
                    {{ head.label }}
                  </div>
                  <div v-else>{{ head.field.key | moment("MMM D") }}</div>
                </template>
                <template #cell(employee)="row">
                  <a class="text-nowrap" :href="`/profile/${row.item.id}`">
                    {{ row.value }}
                  </a>
                </template>
                <template #cell()="row">
                  <div class="text-nowrap">
                    <div v-if="typeof row.value === 'object'">
                      <span>{{ row.value?.first_in || "---" }}</span>
                      <br />
                      <span>{{ row.value?.last_out || "---" }}</span>
                    </div>
                    <div v-else>{{ row.value || "---" }}</div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>